import './cta-hero.scss';

export const setCloseAlertListener = () => {
  document.querySelector('.icon-fa-cross').addEventListener('click', function() {
    document.querySelector('.land-hero__cta').classList.add('hidden');
  });
}